"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeAccountsInstruction = exports.createWithdrawShipsInstruction = exports.createWithdrawArmsInstruction = exports.createWithdrawFoodInstruction = exports.createWithdrawFuelInstruction = exports.createHarvestInstruction = exports.createSettleInstruction = exports.createRepairInstruction = exports.createRefuelInstruction = exports.createRefeedInstruction = exports.createRearmInstruction = exports.createPartialDepositInstruction = exports.createInitialDepositInstruction = exports.createUpdateRewardRateInstruction = exports.createDeregisterShipInstruction = exports.createRegisterShipInstruction = exports.createScoreVarsInitializeInstruction = exports.getAllFleetsForUserPublicKey = exports.getAllFleets = exports.getAllRegisteredShips = exports.getScoreTreasuryAuthAccount = exports.getScoreTreasuryTokenAccount = exports.getScoreVarsShipInfo = exports.decodeEvent = exports.getShipStakingAccountInfo = exports.getScoreVarsInfo = exports.getShipStakingAccount = exports.getScoreEscrowAuthAccount = exports.getScoreEscrowAccount = exports.getScoreVarsShipAccount = exports.getScoreVarsAccount = exports.getScoreIDL = void 0;
const anchor_1 = require("@project-serum/anchor");
const spl_token_1 = require("@solana/spl-token");
const web3_js_1 = require("@solana/web3.js");
const _1 = require(".");
const scoreIdl_1 = require("./util/scoreIdl");
const scoreLogIdl_1 = require("./util/scoreLogIdl");
const util_1 = require("./util");
const factionProgramId = new anchor_1.web3.PublicKey('FACTNmq2FhA2QNTnGM2aWJH3i7zT3cND5CgvjYTjyVYe');
/**
 * Returns the base IDL for the SCORE program following as generated by Anchor with provided program ID appended to metadata.
 *
 * @param programId - Deployed program ID for the SCORE program
 * @returns - The base IDL object
 */
function getScoreIDL(programId) {
    const _tmp = scoreIdl_1.baseIdl;
    _tmp['metadata']['address'] = programId.toBase58();
    return _tmp;
}
exports.getScoreIDL = getScoreIDL;
/**
 * Returns the public key and bump seed for the SCORE variables account.
 *
 * @param programId - Deployed program ID for the SCORE program
 * @returns - [Public key, bump seed]
 */
function getScoreVarsAccount(programId) {
    return __awaiter(this, void 0, void 0, function* () {
        return anchor_1.web3.PublicKey.findProgramAddress([Buffer.from('SCOREVARS')], programId);
    });
}
exports.getScoreVarsAccount = getScoreVarsAccount;
/**
 * Returns the public key and bump seed for the SCORE variables ship account associated with the provided ship mint.
 *
 * @param programId - Deployed program ID for the SCORE program
 * @param shipMint - Ship mint address
 * @returns - [Ship account public key, bump seed]
 */
function getScoreVarsShipAccount(programId, shipMint) {
    return __awaiter(this, void 0, void 0, function* () {
        return anchor_1.web3.PublicKey.findProgramAddress([Buffer.from('SCOREVARS_SHIP'), shipMint.toBuffer()], programId);
    });
}
exports.getScoreVarsShipAccount = getScoreVarsShipAccount;
/**
 * Returns the public key and bump seed for a user's SCORE escrow account.
 *
 * @param programId - Deployed program ID for the SCORE program
 * @param shipMint - Ship mint address
 * @param resourceMint - Mint address for the desired R4 resource
 * @param playerPublicKey - Player's public key
 * @returns - [Escrow account public key, bump seed]
 */
function getScoreEscrowAccount(programId, shipMint, resourceMint, playerPublicKey) {
    return __awaiter(this, void 0, void 0, function* () {
        const seeds = [
            Buffer.from('SCORE_ESCROW'),
            playerPublicKey.toBuffer(),
            shipMint.toBuffer(),
        ];
        if (resourceMint !== null) {
            seeds.push(resourceMint.toBuffer());
        }
        return anchor_1.web3.PublicKey.findProgramAddress(seeds, programId);
    });
}
exports.getScoreEscrowAccount = getScoreEscrowAccount;
/**
 * Returns the SCORE escrow authority account
 *
 * @param programId - Deployed program ID for the SCORE program
 * @param shipMint - Ship mint address
 * @param playerPublicKey - Player's public key
 * @returns - [Authority account public key, bump seed]
 */
function getScoreEscrowAuthAccount(programId, shipMint, playerPublicKey) {
    return __awaiter(this, void 0, void 0, function* () {
        return anchor_1.web3.PublicKey.findProgramAddress([
            Buffer.from('SCORE_ESCROW_AUTHORITY'),
            playerPublicKey.toBuffer(),
            shipMint.toBuffer(),
        ], programId);
    });
}
exports.getScoreEscrowAuthAccount = getScoreEscrowAuthAccount;
/**
 * Returns a user's ship staking account
 *
 * @param programId - Deployed program ID for the SCORE program
 * @param assetMint - Mint address for the desired resource
 * @param playerPublicKey - Player's public key
 * @returns - [Staking account public key, bump seed]
 */
function getShipStakingAccount(programId, assetMint, playerPublicKey) {
    return __awaiter(this, void 0, void 0, function* () {
        return anchor_1.web3.PublicKey.findProgramAddress([
            Buffer.from('SCORE_INFO'),
            playerPublicKey.toBuffer(),
            assetMint.toBuffer(),
        ], programId);
    });
}
exports.getShipStakingAccount = getShipStakingAccount;
/**
 * Returns the current SCORE variables' info.
 *
 * @param connection - web3.Connection object
 * @param programId - Deployed program ID for the SCORE program
 */
function getScoreVarsInfo(connection, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const idl = getScoreIDL(programId);
        const program = new anchor_1.Program(idl, programId, provider);
        const [scoreVarsAccount] = yield getScoreVarsAccount(programId);
        const obj = yield program.account.scoreVars.fetch(scoreVarsAccount);
        return obj;
    });
}
exports.getScoreVarsInfo = getScoreVarsInfo;
/**
 * Returns the current ship staking account info for a player and ship mint.
 *
 * @param connection - web3.Connection object
 * @param programId - Deployed program ID for the SCORE program
 * @param shipMint - ship mint address
 * @param playerPublicKey - Player's public key
 */
function getShipStakingAccountInfo(connection, programId, shipMint, playerPublicKey) {
    return __awaiter(this, void 0, void 0, function* () {
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const idl = getScoreIDL(programId);
        const program = new anchor_1.Program(idl, programId, provider);
        const [shipStakingAccount] = yield getShipStakingAccount(programId, shipMint, playerPublicKey);
        const obj = yield program.account.shipStaking.fetch(shipStakingAccount);
        return obj;
    });
}
exports.getShipStakingAccountInfo = getShipStakingAccountInfo;
/**
 * Returns decoded event
 *
 * @param connection - web3.Connection object
 * @param programId - Deployed program ID for the SCORE program
 * @param event - Event to decode
 */
function decodeEvent(connection, programId, event) {
    return __awaiter(this, void 0, void 0, function* () {
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(scoreLogIdl_1.scoreLogBaseIdl, programId, provider);
        return program.coder.events.decode(event);
    });
}
exports.decodeEvent = decodeEvent;
/**
 * Returns the current SCORE variables info for a designated ship mint.
 *
 * @param connection - web3.Connection object
 * @param programId - Deployed program ID for the SCORE program
 * @param shipMint - Ship mint address
 */
function getScoreVarsShipInfo(connection, programId, shipMint) {
    return __awaiter(this, void 0, void 0, function* () {
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const idl = getScoreIDL(programId);
        const program = new anchor_1.Program(idl, programId, provider);
        const [scoreVarsShipAccount] = yield getScoreVarsShipAccount(programId, shipMint);
        const obj = yield program.account.scoreVarsShip.fetch(scoreVarsShipAccount);
        return obj;
    });
}
exports.getScoreVarsShipInfo = getScoreVarsShipInfo;
/**
 * Returns the public key and bump seed for the SCORE treasury token account.
 *
 * @param programId - Deployed program ID for the SCORE program
 * @returns - [Treasury's Public key, bump seed]
 */
function getScoreTreasuryTokenAccount(programId) {
    return __awaiter(this, void 0, void 0, function* () {
        return anchor_1.web3.PublicKey.findProgramAddress([Buffer.from('SCORE_TREASURY')], programId);
    });
}
exports.getScoreTreasuryTokenAccount = getScoreTreasuryTokenAccount;
/**
 * Returns the treasury authority account
 *
 * @param programId - Deployed program ID for the SCORE program
 * @returns - [Authority account public key, bump seed]
 */
function getScoreTreasuryAuthAccount(programId) {
    return __awaiter(this, void 0, void 0, function* () {
        return anchor_1.web3.PublicKey.findProgramAddress([Buffer.from('SCORE_TREASURY_AUTHORITY')], programId);
    });
}
exports.getScoreTreasuryAuthAccount = getScoreTreasuryAuthAccount;
/**
 * Returns a list registered ships
 *
 * @param connection - web3.Connection object
 * @param programId - Deployed program ID for the SCORE program
 * @returns - [Ship Staking Account Infos]
 */
function getAllRegisteredShips(connection, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const idl = getScoreIDL(programId);
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(idl, programId, provider);
        const _shipsRegistered = yield program.account.scoreVarsShip.all();
        const shipsRegistered = [];
        for (const ship of _shipsRegistered) {
            shipsRegistered.push(ship.account);
        }
        return shipsRegistered;
    });
}
exports.getAllRegisteredShips = getAllRegisteredShips;
/**
 * Returns a list of all fleets
 *
 * @param connection - web3.Connection object
 * @param programId - Deployed program ID for the SCORE program
 * @returns - [Ship Staking Account Infos]
 */
function getAllFleets(connection, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const idl = getScoreIDL(programId);
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(idl, programId, provider);
        const _shipStakingAccounts = yield program.account.shipStaking.all();
        const shipStakingAccounts = [];
        for (const stakingAccount of _shipStakingAccounts) {
            shipStakingAccounts.push(stakingAccount.account);
        }
        return shipStakingAccounts;
    });
}
exports.getAllFleets = getAllFleets;
/**
 * Returns a list of player deployed fleets to the SCORE program
 *
 * @param connection - web3.Connection object
 * @param playerPublicKey - Player's public key
 * @param programId - Deployed program ID for the SCORE program
 * @returns - [Ship Staking Account Infos]
 */
function getAllFleetsForUserPublicKey(connection, playerPublicKey, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const idl = getScoreIDL(programId);
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(idl, programId, provider);
        const shipsRegistered = yield program.account.scoreVarsShip.all();
        const playerShipStakingAccounts = [];
        for (const ship of shipsRegistered) {
            const [playerShipStakingAccount] = yield getShipStakingAccount(programId, ship.account.shipMint, playerPublicKey);
            playerShipStakingAccounts.push(playerShipStakingAccount);
        }
        const _playerFleets = yield program.account.shipStaking.fetchMultiple(playerShipStakingAccounts);
        const playerFleets = _playerFleets
            .filter((fleet) => fleet !== null)
            .map((fleet) => fleet);
        return playerFleets;
    });
}
exports.getAllFleetsForUserPublicKey = getAllFleetsForUserPublicKey;
/**
 * Initializes Score variables account and creates ATLAS treasury token account
 *
 * @param connection - web3.Connection object
 * @param updateAuthorityAccount - Desired authority public key
 * @param atlasMint - ATLAS mint address
 * @param fuelMint - Fuel mint address
 * @param foodMint - Food mint address
 * @param armsMint - Arms mint address
 * @param toolkitMint - Toolkit mint address
 * @param programId - Deployed program ID for the SCORE program
 */
function createScoreVarsInitializeInstruction(connection, updateAuthorityAccount, atlasMint, fuelMint, foodMint, armsMint, toolkitMint, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const idl = getScoreIDL(programId);
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(idl, programId, provider);
        const [treasuryTokenAccount, treasuryBump] = yield getScoreTreasuryTokenAccount(programId);
        const [treasuryAuthorityAccount, treasuryAuthBump] = yield getScoreTreasuryAuthAccount(programId);
        const [scoreVarsAccount, scoreVarsBump] = yield getScoreVarsAccount(programId);
        const ix = yield program.instruction.processInitialize(scoreVarsBump, treasuryBump, treasuryAuthBump, {
            accounts: {
                updateAuthorityAccount: updateAuthorityAccount,
                scoreVarsAccount: scoreVarsAccount,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                systemProgram: web3_js_1.SystemProgram.programId,
                rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
                treasuryTokenAccount: treasuryTokenAccount,
                treasuryAuthorityAccount: treasuryAuthorityAccount,
                atlasMint: atlasMint,
                fuelMint: fuelMint,
                foodMint: foodMint,
                armsMint: armsMint,
                toolkitMint: toolkitMint,
            },
            signers: [],
        });
        return ix;
    });
}
exports.createScoreVarsInitializeInstruction = createScoreVarsInitializeInstruction;
/**
 * Initiates Score variables account for a provided ship mint.
 *
 * @param connection - web3.Connection object
 * @param updateAuthorityAccount - valid authority public key
 * @param shipMint - Ship mint address
 * @param fuelMaxReserve - Max fuel in token units
 * @param foodMaxReserve - Max food in token units
 * @param armsMaxReserve - Max arms in token units
 * @param toolkitMaxReserve - Max toolkits in token units
 * @param millisecondsToBurnFuel - the amount of milliseconds to burn one fuel token
 * @param millisecondsToBurnFood - the amount of milliseconds to burn one food token
 * @param millisecondsToBurnArms - the amount of milliseconds to burn one arms token
 * @param millisecondsToBurnToolkit - the amount of milliseconds to burn one toolkit token
 * @param rewardRatePerSecond - Atlas rewarded per second
 * @param programId - Deployed Score program ID
 */
function createRegisterShipInstruction(connection, updateAuthorityAccount, shipMint, fuelMaxReserve, foodMaxReserve, armsMaxReserve, toolkitMaxReserve, millisecondsToBurnFuel, millisecondsToBurnFood, millisecondsToBurnArms, millisecondsToBurnToolkit, rewardRatePerSecond, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const idl = getScoreIDL(programId);
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(idl, programId, provider);
        const [scoreVarsShipAccount, scoreVarsShipBump] = yield getScoreVarsShipAccount(programId, shipMint);
        const [scoreVarsAccount, scoreVarsBump] = yield getScoreVarsAccount(programId);
        const ix = yield program.instruction.processRegisterShip(scoreVarsBump, scoreVarsShipBump, new anchor_1.BN(rewardRatePerSecond), fuelMaxReserve, foodMaxReserve, armsMaxReserve, toolkitMaxReserve, millisecondsToBurnFuel, millisecondsToBurnFood, millisecondsToBurnArms, millisecondsToBurnToolkit, {
            accounts: {
                updateAuthorityAccount: updateAuthorityAccount,
                scoreVarsAccount: scoreVarsAccount,
                scoreVarsShipAccount: scoreVarsShipAccount,
                shipMint: shipMint,
                systemProgram: web3_js_1.SystemProgram.programId,
            },
            signers: [],
        });
        return ix;
    });
}
exports.createRegisterShipInstruction = createRegisterShipInstruction;
/**
 * Deregister a ship that was already registered (Admin only)
 * Only to be called in the event of an invalid register
 *
 * @param connection - web3.Connection object
 * @param updateAuthorityAccount - valid authority public key
 * @param shipMint - Ship mint address
 * @param programId - Deployed Score program ID
 */
function createDeregisterShipInstruction(connection, updateAuthorityAccount, shipMint, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const idl = getScoreIDL(programId);
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(idl, programId, provider);
        const [scoreVarsShipAccount, scoreVarsShipBump] = yield getScoreVarsShipAccount(programId, shipMint);
        const [scoreVarsAccount, scoreVarsBump] = yield getScoreVarsAccount(programId);
        const ix = yield program.instruction.processDeregisterShip(scoreVarsBump, scoreVarsShipBump, {
            accounts: {
                updateAuthorityAccount: updateAuthorityAccount,
                scoreVarsAccount: scoreVarsAccount,
                scoreVarsShipAccount: scoreVarsShipAccount,
                shipMint: shipMint,
            },
            signers: [],
        });
        return ix;
    });
}
exports.createDeregisterShipInstruction = createDeregisterShipInstruction;
/**
 * Update a ship's reward rate (Admin only)
 *
 * @param connection - web3.Connection object
 * @param updateAuthorityAccount - valid authority public key
 * @param shipMint - Ship mint address
 * @param newRewardRatePerSecond - New Atlas rewards per second in base units
 * @param programId - Deployed Score program ID
 */
function createUpdateRewardRateInstruction(connection, updateAuthorityAccount, shipMint, newRewardRatePerSecond, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const idl = getScoreIDL(programId);
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(idl, programId, provider);
        const [scoreVarsShipAccount, scoreVarsShipBump] = yield getScoreVarsShipAccount(programId, shipMint);
        const [scoreVarsAccount, scoreVarsBump] = yield getScoreVarsAccount(programId);
        const ix = yield program.instruction.processUpdateRewardRate(scoreVarsBump, scoreVarsShipBump, new anchor_1.BN(newRewardRatePerSecond), {
            accounts: {
                updateAuthorityAccount: updateAuthorityAccount,
                scoreVarsAccount: scoreVarsAccount,
                scoreVarsShipAccount: scoreVarsShipAccount,
                shipMint: shipMint,
            },
            signers: [],
        });
        return ix;
    });
}
exports.createUpdateRewardRateInstruction = createUpdateRewardRateInstruction;
/**
 * Provides a transaction instruction which can be used to deposit a specified quantity of ships to a player's ship staking account.
 *
 * @param connection - web3.Connection object
 * @param playerPublicKey - Player's public key
 * @param shipQuantity - Quantity to deposit as u64
 * @param shipMint - Ship mint address
 * @param shipTokenAccount - Token account for the ship resource being deposited
 * @param programId - Deployed program ID for the SCORE program
 */
function createInitialDepositInstruction(connection, playerPublicKey, shipQuantity, shipMint, shipTokenAccount, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const [escrowAuthority, escrowAuthBump] = yield getScoreEscrowAuthAccount(programId, shipMint, playerPublicKey);
        const [shipEscrow, escrowBump] = yield getScoreEscrowAccount(programId, shipMint, null, playerPublicKey);
        const [shipStakingAccount, stakingBump] = yield getShipStakingAccount(programId, shipMint, playerPublicKey);
        const [scoreVarsShipAccount, scoreVarsShipBump] = yield getScoreVarsShipAccount(programId, shipMint);
        const [playerFactionPDA] = yield (0, _1.getPlayerFactionPDA)(playerPublicKey, factionProgramId);
        const idl = getScoreIDL(programId);
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(idl, programId, provider);
        const ix = yield program.instruction.processInitialDeposit(stakingBump, scoreVarsShipBump, escrowAuthBump, escrowBump, new anchor_1.BN(shipQuantity), {
            accounts: {
                playerAccount: playerPublicKey,
                shipStakingAccount: shipStakingAccount,
                scoreVarsShipAccount: scoreVarsShipAccount,
                playerFactionAccount: playerFactionPDA,
                escrowAuthority: escrowAuthority,
                systemProgram: anchor_1.web3.SystemProgram.programId,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                clock: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
                rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
                shipMint: shipMint,
                shipTokenAccountSource: shipTokenAccount,
                shipTokenAccountEscrow: shipEscrow,
            },
        });
        return ix;
    });
}
exports.createInitialDepositInstruction = createInitialDepositInstruction;
/**
 * Provides a transaction instruction which can be used to deposit a specified quantity of ships to an already deployed player's ship staking account.
 *
 * @param connection - web3.Connection object
 * @param playerPublicKey - Player's public key
 * @param shipQuantity - Quantity to deposit as u64
 * @param shipMint - Ship mint address
 * @param shipTokenAccount - Token account for the ship resource being deposited
 * @param programId - Deployed program ID for the SCORE program
 */
function createPartialDepositInstruction(connection, playerPublicKey, shipQuantity, shipMint, shipTokenAccount, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const [escrowAuthority, escrowAuthBump] = yield getScoreEscrowAuthAccount(programId, shipMint, playerPublicKey);
        const [shipEscrow, escrowBump] = yield getScoreEscrowAccount(programId, shipMint, null, playerPublicKey);
        const [shipStakingAccount, stakingBump] = yield getShipStakingAccount(programId, shipMint, playerPublicKey);
        const [scoreVarsShipAccount, scoreVarsShipBump] = yield getScoreVarsShipAccount(programId, shipMint);
        const idl = getScoreIDL(programId);
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(idl, programId, provider);
        const ix = yield program.instruction.processPartialDeposit(stakingBump, scoreVarsShipBump, escrowAuthBump, escrowBump, new anchor_1.BN(shipQuantity), {
            accounts: {
                playerAccount: playerPublicKey,
                shipStakingAccount: shipStakingAccount,
                scoreVarsShipAccount: scoreVarsShipAccount,
                escrowAuthority: escrowAuthority,
                systemProgram: anchor_1.web3.SystemProgram.programId,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                clock: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
                shipMint: shipMint,
                shipTokenAccountSource: shipTokenAccount,
                shipTokenAccountEscrow: shipEscrow,
            },
        });
        return ix;
    });
}
exports.createPartialDepositInstruction = createPartialDepositInstruction;
/**
 * Provides a transaction instruction which can be used to transfer arms resources to a player's arms escrow account.
 *
 * @param connection - web3.Connection object
 * @param tokenOwnerPublickey - Resource Token Account Owner
 * @param playerPublicKey - Player's public key
 * @param armsQuantity - Arms resource quantity as u64
 * @param shipMint - Ship mint address
 * @param armsMint - Arms resource mint address
 * @param armsTokenAccount - Token account for the arms resources being deposited
 * @param programId - Deployed program ID for the SCORE program
 */
function createRearmInstruction(connection, tokenOwnerPublickey, playerPublicKey, armsQuantity, shipMint, armsMint, armsTokenAccount, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const [escrowAuthority, escrowAuthBump] = yield getScoreEscrowAuthAccount(programId, shipMint, playerPublicKey);
        const [armsEscrow, escrowBump] = yield getScoreEscrowAccount(programId, shipMint, armsMint, playerPublicKey);
        const [shipStakingAccount, stakingBump] = yield getShipStakingAccount(programId, shipMint, playerPublicKey);
        const [scoreVarsShipAccount, scoreVarsShipBump] = yield getScoreVarsShipAccount(programId, shipMint);
        const [scoreVarsAccount, scoreVarsBump] = yield getScoreVarsAccount(programId);
        const idl = getScoreIDL(programId);
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(idl, programId, provider);
        const ix = yield program.instruction.processRearm(stakingBump, scoreVarsBump, scoreVarsShipBump, escrowAuthBump, escrowBump, new anchor_1.BN(armsQuantity), {
            accounts: {
                tokenOwnerAccount: tokenOwnerPublickey,
                playerAccount: playerPublicKey,
                shipStakingAccount: shipStakingAccount,
                scoreVarsAccount: scoreVarsAccount,
                scoreVarsShipAccount: scoreVarsShipAccount,
                escrowAuthority: escrowAuthority,
                systemProgram: anchor_1.web3.SystemProgram.programId,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                clock: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
                rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
                shipMint: shipMint,
                armsMint: armsMint,
                armsTokenAccountSource: armsTokenAccount,
                armsTokenAccountEscrow: armsEscrow,
            },
        });
        return ix;
    });
}
exports.createRearmInstruction = createRearmInstruction;
/**
 * Provides a transaction instruction which can be used to transfer food resources to a player's food escrow account.
 *
 * @param connection - web3.Connection object
 * @param tokenOwnerPublickey - Resource Token Account Owner
 * @param playerPublicKey - Player's public key
 * @param foodQuantity - Food resource quantity as u64
 * @param shipMint - Ship mint address
 * @param foodMint - Food resource mint address
 * @param foodTokenAccount - Token account for the food resource being deposited
 * @param programId - Deployed program ID for the SCORE program
 */
function createRefeedInstruction(connection, tokenOwnerPublickey, playerPublicKey, foodQuantity, shipMint, foodMint, foodTokenAccount, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const [escrowAuthority, escrowAuthBump] = yield getScoreEscrowAuthAccount(programId, shipMint, playerPublicKey);
        const [foodEscrow, escrowBump] = yield getScoreEscrowAccount(programId, shipMint, foodMint, playerPublicKey);
        const [shipStakingAccount, stakingBump] = yield getShipStakingAccount(programId, shipMint, playerPublicKey);
        const [scoreVarsShipAccount, scoreVarsShipBump] = yield getScoreVarsShipAccount(programId, shipMint);
        const [scoreVarsAccount, scoreVarsBump] = yield getScoreVarsAccount(programId);
        const idl = getScoreIDL(programId);
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(idl, programId, provider);
        const ix = yield program.instruction.processRefeed(stakingBump, scoreVarsBump, scoreVarsShipBump, escrowAuthBump, escrowBump, new anchor_1.BN(foodQuantity), {
            accounts: {
                tokenOwnerAccount: tokenOwnerPublickey,
                playerAccount: playerPublicKey,
                shipStakingAccount: shipStakingAccount,
                scoreVarsAccount: scoreVarsAccount,
                scoreVarsShipAccount: scoreVarsShipAccount,
                escrowAuthority: escrowAuthority,
                systemProgram: anchor_1.web3.SystemProgram.programId,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                clock: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
                rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
                shipMint: shipMint,
                foodMint: foodMint,
                foodTokenAccountSource: foodTokenAccount,
                foodTokenAccountEscrow: foodEscrow,
            },
        });
        return ix;
    });
}
exports.createRefeedInstruction = createRefeedInstruction;
/**
 * Provides a transaction instruction which can be used to transfer fuel resources to a player's fuel escrow account.
 *
 * @param connection - web3.Connection object
 * @param tokenOwnerPublickey - Resource Token Account Owner
 * @param playerPublicKey - Player's public key
 * @param fuelQuantity - Fuel resource quantity as u64
 * @param shipMint - Ship mint address
 * @param fuelMint - Fuel resource mint address
 * @param fuelTokenAccount - Token account for the fuel resource being deposited
 * @param programId - Deployed program ID for the SCORE program
 */
function createRefuelInstruction(connection, tokenOwnerPublickey, playerPublicKey, fuelQuantity, shipMint, fuelMint, fuelTokenAccount, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const [escrowAuthority, escrowAuthBump] = yield getScoreEscrowAuthAccount(programId, shipMint, playerPublicKey);
        const [fuelEscrow, escrowBump] = yield getScoreEscrowAccount(programId, shipMint, fuelMint, playerPublicKey);
        const [shipStakingAccount, stakingBump] = yield getShipStakingAccount(programId, shipMint, playerPublicKey);
        const [scoreVarsShipAccount, scoreVarsShipBump] = yield getScoreVarsShipAccount(programId, shipMint);
        const [scoreVarsAccount, scoreVarsBump] = yield getScoreVarsAccount(programId);
        const idl = getScoreIDL(programId);
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(idl, programId, provider);
        const ix = yield program.instruction.processRefuel(stakingBump, scoreVarsBump, scoreVarsShipBump, escrowAuthBump, escrowBump, new anchor_1.BN(fuelQuantity), {
            accounts: {
                tokenOwnerAccount: tokenOwnerPublickey,
                playerAccount: playerPublicKey,
                shipStakingAccount: shipStakingAccount,
                scoreVarsAccount: scoreVarsAccount,
                scoreVarsShipAccount: scoreVarsShipAccount,
                escrowAuthority: escrowAuthority,
                systemProgram: anchor_1.web3.SystemProgram.programId,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                clock: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
                rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
                shipMint: shipMint,
                fuelMint: fuelMint,
                fuelTokenAccountSource: fuelTokenAccount,
                fuelTokenAccountEscrow: fuelEscrow,
            },
        });
        return ix;
    });
}
exports.createRefuelInstruction = createRefuelInstruction;
/**
 * Provides a transaction instruction which can be used to transfer toolkit resources to a player's toolkit escrow account.
 *
 * @param connection - web3.Connection object
 * @param tokenOwnerPublickey - Resource Token Account Owner
 * @param playerPublicKey - Player's public key
 * @param toolkitQuantity - Toolkit resource quantity as u64
 * @param shipMint - Ship mint address
 * @param toolkitMint - Toolkit resource mint address
 * @param toolkitTokenAccount - Token account for the toolkit resource being deposited
 * @param programId - Deployed program ID for the SCORE program
 */
function createRepairInstruction(connection, tokenOwnerPublickey, playerPublicKey, toolkitQuantity, shipMint, toolkitMint, toolkitTokenAccount, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const [shipStakingAccount, stakingBump] = yield getShipStakingAccount(programId, shipMint, playerPublicKey);
        const [scoreVarsShipAccount, scoreVarsShipBump] = yield getScoreVarsShipAccount(programId, shipMint);
        const [scoreVarsAccount, scoreVarsBump] = yield getScoreVarsAccount(programId);
        const idl = getScoreIDL(programId);
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(idl, programId, provider);
        const ix = yield program.instruction.processRepair(stakingBump, scoreVarsBump, scoreVarsShipBump, new anchor_1.BN(toolkitQuantity), {
            accounts: {
                tokenOwnerAccount: tokenOwnerPublickey,
                playerAccount: playerPublicKey,
                shipStakingAccount: shipStakingAccount,
                scoreVarsAccount: scoreVarsAccount,
                scoreVarsShipAccount: scoreVarsShipAccount,
                systemProgram: anchor_1.web3.SystemProgram.programId,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                clock: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
                rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
                shipMint: shipMint,
                toolkitMint: toolkitMint,
                toolkitTokenAccountSource: toolkitTokenAccount,
            },
        });
        return ix;
    });
}
exports.createRepairInstruction = createRepairInstruction;
/**
 * Returns an instruction that can be used to update the amount of ATLAS in a player's pending rewards and update staked time paid
 *
 * @param connection - web3.Connection object
 * @param playerPublicKey - Player's public key
 * @param updateAuthorityAccount - valid authority public key
 * @param shipMint - Ship mint address
 * @param programId - Deployed program ID for the SCORE program
 */
function createSettleInstruction(connection, playerPublicKey, updateAuthorityAccount, shipMint, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const [shipStakingAccount, stakingBump] = yield getShipStakingAccount(programId, shipMint, playerPublicKey);
        const [scoreVarsShipAccount, scoreVarsShipBump] = yield getScoreVarsShipAccount(programId, shipMint);
        const [scoreVarsAccount, scoreVarsBump] = yield getScoreVarsAccount(programId);
        const idl = getScoreIDL(programId);
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(idl, programId, provider);
        const ix = yield program.instruction.processSettle(stakingBump, scoreVarsBump, scoreVarsShipBump, {
            accounts: {
                playerAccount: playerPublicKey,
                updateAuthorityAccount: updateAuthorityAccount,
                shipStakingAccount: shipStakingAccount,
                scoreVarsShipAccount: scoreVarsShipAccount,
                scoreVarsAccount: scoreVarsAccount,
                clock: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
                shipMint: shipMint,
            },
        });
        return ix;
    });
}
exports.createSettleInstruction = createSettleInstruction;
/**
 *
 * @param connection - web3.Connection object
 * @param playerPublicKey - Player's public key
 * @param atlasMint - Atlas mint address
 * @param shipMint - Ship mint address
 * @param programId - Deployed program ID for the SCORE program
 */
function createHarvestInstruction(connection, playerPublicKey, atlasMint, shipMint, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const [shipStakingAccount, stakingBump] = yield getShipStakingAccount(programId, shipMint, playerPublicKey);
        const [scoreVarsShipAccount, scoreVarsShipBump] = yield getScoreVarsShipAccount(programId, shipMint);
        const [treasuryTokenAccount, treasuryBump] = yield getScoreTreasuryTokenAccount(programId);
        const [treasuryAuthorityAccount, treasuryAuthBump] = yield getScoreTreasuryAuthAccount(programId);
        const idl = getScoreIDL(programId);
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(idl, programId, provider);
        const ixSet = {
            signers: [],
            instructions: [],
        };
        // Fetch user's atlas token account
        let playerAtlasTokenAccount;
        const response = yield (0, util_1.getTokenAccount)(connection, playerPublicKey, atlasMint);
        const tokenAccount = response.tokenAccount;
        if ('createInstruction' in response) {
            ixSet.instructions.push(response.createInstruction);
        }
        if (tokenAccount instanceof anchor_1.web3.Keypair) {
            playerAtlasTokenAccount = tokenAccount.publicKey;
            ixSet.signers.push(tokenAccount);
        }
        else {
            playerAtlasTokenAccount = tokenAccount;
        }
        const ix = yield program.instruction.processHarvest(stakingBump, scoreVarsShipBump, treasuryBump, treasuryAuthBump, {
            accounts: {
                playerAccount: playerPublicKey,
                shipStakingAccount: shipStakingAccount,
                scoreVarsShipAccount: scoreVarsShipAccount,
                playerAtlasTokenAccount: playerAtlasTokenAccount,
                treasuryTokenAccount: treasuryTokenAccount,
                treasuryAuthorityAccount: treasuryAuthorityAccount,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                clock: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
                shipMint: shipMint,
            },
        });
        ixSet.instructions.push(ix);
        return ixSet;
    });
}
exports.createHarvestInstruction = createHarvestInstruction;
/**
 * Withdraw Fuel from Escrow - required before withdrawShip
 *
 * @param connection - web3.Connection object
 * @param playerPublicKey - Player's public key
 * @param fuelMint - Fuel resource mint address
 * @param shipMint - Ship mint address
 * @param programId - Deployed program ID for the SCORE program
 */
function createWithdrawFuelInstruction(connection, playerPublicKey, fuelMint, shipMint, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const [escrowAuthority, escrowAuthBump] = yield getScoreEscrowAuthAccount(programId, shipMint, playerPublicKey);
        const [fuelEscrow, escrowBump] = yield getScoreEscrowAccount(programId, shipMint, fuelMint, playerPublicKey);
        const [shipStakingAccount, stakingBump] = yield getShipStakingAccount(programId, shipMint, playerPublicKey);
        const [scoreVarsShipAccount, scoreVarsShipBump] = yield getScoreVarsShipAccount(programId, shipMint);
        const [scoreVarsAccount, scoreVarsBump] = yield getScoreVarsAccount(programId);
        const idl = getScoreIDL(programId);
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(idl, programId, provider);
        const ixSet = {
            signers: [],
            instructions: [],
        };
        // Fetch user's fuel token account
        let fuelTokenAccount;
        const response = yield (0, util_1.getTokenAccount)(connection, playerPublicKey, fuelMint);
        const tokenAccount = response.tokenAccount;
        if ('createInstruction' in response) {
            ixSet.instructions.push(response.createInstruction);
        }
        if (tokenAccount instanceof anchor_1.web3.Keypair) {
            fuelTokenAccount = tokenAccount.publicKey;
            ixSet.signers.push(tokenAccount);
        }
        else {
            fuelTokenAccount = tokenAccount;
        }
        const ix = yield program.instruction.processWithdrawFuel(stakingBump, scoreVarsBump, scoreVarsShipBump, escrowAuthBump, escrowBump, {
            accounts: {
                playerAccount: playerPublicKey,
                shipStakingAccount: shipStakingAccount,
                scoreVarsAccount: scoreVarsAccount,
                scoreVarsShipAccount: scoreVarsShipAccount,
                fuelTokenAccountEscrow: fuelEscrow,
                fuelTokenAccountReturn: fuelTokenAccount,
                fuelMint: fuelMint,
                escrowAuthority: escrowAuthority,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                clock: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
                shipMint: shipMint,
            },
        });
        ixSet.instructions.push(ix);
        return ixSet;
    });
}
exports.createWithdrawFuelInstruction = createWithdrawFuelInstruction;
/**
 * Withdraw Food from Escrow - required before withdrawShip
 *
 * @param connection - web3.Connection object
 * @param playerPublicKey - Player's public key
 * @param foodMint - Food resource mint address
 * @param shipMint - Ship mint address
 * @param programId - Deployed program ID for the SCORE program
 */
function createWithdrawFoodInstruction(connection, playerPublicKey, foodMint, shipMint, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const [escrowAuthority, escrowAuthBump] = yield getScoreEscrowAuthAccount(programId, shipMint, playerPublicKey);
        const [foodEscrow, escrowBump] = yield getScoreEscrowAccount(programId, shipMint, foodMint, playerPublicKey);
        const [shipStakingAccount, stakingBump] = yield getShipStakingAccount(programId, shipMint, playerPublicKey);
        const [scoreVarsShipAccount, scoreVarsShipBump] = yield getScoreVarsShipAccount(programId, shipMint);
        const [scoreVarsAccount, scoreVarsBump] = yield getScoreVarsAccount(programId);
        const idl = getScoreIDL(programId);
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(idl, programId, provider);
        const ixSet = {
            signers: [],
            instructions: [],
        };
        // Fetch user's food token account
        let foodTokenAccount;
        const response = yield (0, util_1.getTokenAccount)(connection, playerPublicKey, foodMint);
        const tokenAccount = response.tokenAccount;
        if ('createInstruction' in response) {
            ixSet.instructions.push(response.createInstruction);
        }
        if (tokenAccount instanceof anchor_1.web3.Keypair) {
            foodTokenAccount = tokenAccount.publicKey;
            ixSet.signers.push(tokenAccount);
        }
        else {
            foodTokenAccount = tokenAccount;
        }
        const ix = yield program.instruction.processWithdrawFood(stakingBump, scoreVarsBump, scoreVarsShipBump, escrowAuthBump, escrowBump, {
            accounts: {
                playerAccount: playerPublicKey,
                shipStakingAccount: shipStakingAccount,
                scoreVarsAccount: scoreVarsAccount,
                scoreVarsShipAccount: scoreVarsShipAccount,
                foodTokenAccountEscrow: foodEscrow,
                foodTokenAccountReturn: foodTokenAccount,
                foodMint: foodMint,
                escrowAuthority: escrowAuthority,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                clock: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
                shipMint: shipMint,
            },
        });
        ixSet.instructions.push(ix);
        return ixSet;
    });
}
exports.createWithdrawFoodInstruction = createWithdrawFoodInstruction;
/**
 * Withdraw Arms from Escrow - required before withdrawShip
 *
 * @param connection - web3.Connection object
 * @param playerPublicKey - Player's public key
 * @param armsMint - Arms resource mint address
 * @param shipMint - Ship mint address
 * @param programId - Deployed program ID for the SCORE program
 */
function createWithdrawArmsInstruction(connection, playerPublicKey, armsMint, shipMint, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const [escrowAuthority, escrowAuthBump] = yield getScoreEscrowAuthAccount(programId, shipMint, playerPublicKey);
        const [armsEscrow, escrowBump] = yield getScoreEscrowAccount(programId, shipMint, armsMint, playerPublicKey);
        const [shipStakingAccount, stakingBump] = yield getShipStakingAccount(programId, shipMint, playerPublicKey);
        const [scoreVarsShipAccount, scoreVarsShipBump] = yield getScoreVarsShipAccount(programId, shipMint);
        const [scoreVarsAccount, scoreVarsBump] = yield getScoreVarsAccount(programId);
        const idl = getScoreIDL(programId);
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(idl, programId, provider);
        const ixSet = {
            signers: [],
            instructions: [],
        };
        // Fetch user's arms token account
        let armsTokenAccount;
        const response = yield (0, util_1.getTokenAccount)(connection, playerPublicKey, armsMint);
        const tokenAccount = response.tokenAccount;
        if ('createInstruction' in response) {
            ixSet.instructions.push(response.createInstruction);
        }
        if (tokenAccount instanceof anchor_1.web3.Keypair) {
            armsTokenAccount = tokenAccount.publicKey;
            ixSet.signers.push(tokenAccount);
        }
        else {
            armsTokenAccount = tokenAccount;
        }
        const ix = yield program.instruction.processWithdrawArms(stakingBump, scoreVarsBump, scoreVarsShipBump, escrowAuthBump, escrowBump, {
            accounts: {
                playerAccount: playerPublicKey,
                shipStakingAccount: shipStakingAccount,
                scoreVarsAccount: scoreVarsAccount,
                scoreVarsShipAccount: scoreVarsShipAccount,
                armsTokenAccountEscrow: armsEscrow,
                armsTokenAccountReturn: armsTokenAccount,
                armsMint: armsMint,
                escrowAuthority: escrowAuthority,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                clock: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
                shipMint: shipMint,
            },
        });
        ixSet.instructions.push(ix);
        return ixSet;
    });
}
exports.createWithdrawArmsInstruction = createWithdrawArmsInstruction;
/**
 * Withdraw Ships from Escrow
 *
 * @param connection - web3.Connection object
 * @param playerPublicKey - Player's public key
 * @param shipMint - Ship mint address
 * @param atlasMint - ATLAS token mint
 * @param toolkitMint - Toolkit resource mint address
 * @param programId - Deployed program ID for the SCORE program
 */
function createWithdrawShipsInstruction(connection, playerPublicKey, shipMint, atlasMint, toolkitMint, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const [escrowAuthority, escrowAuthBump] = yield getScoreEscrowAuthAccount(programId, shipMint, playerPublicKey);
        const [shipEscrow, escrowBump] = yield getScoreEscrowAccount(programId, shipMint, null, playerPublicKey);
        const [shipStakingAccount, stakingBump] = yield getShipStakingAccount(programId, shipMint, playerPublicKey);
        const [scoreVarsShipAccount, scoreVarsShipBump] = yield getScoreVarsShipAccount(programId, shipMint);
        const [scoreVarsAccount, scoreVarsBump] = yield getScoreVarsAccount(programId);
        const [treasuryTokenAccount, treasuryBump] = yield getScoreTreasuryTokenAccount(programId);
        const [treasuryAuthorityAccount, treasuryAuthBump] = yield getScoreTreasuryAuthAccount(programId);
        const ixSet = {
            signers: [],
            instructions: [],
        };
        const idl = getScoreIDL(programId);
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(idl, programId, provider);
        // Get user's Atlas token account
        let playerAtlasTokenAccount;
        const atlasResponse = yield (0, util_1.getTokenAccount)(connection, playerPublicKey, atlasMint);
        const potentialAtlasTokenAccount = atlasResponse.tokenAccount;
        if ('createInstruction' in atlasResponse) {
            ixSet.instructions.push(atlasResponse.createInstruction);
        }
        if (potentialAtlasTokenAccount instanceof anchor_1.web3.Keypair) {
            playerAtlasTokenAccount = potentialAtlasTokenAccount.publicKey;
            ixSet.signers.push(potentialAtlasTokenAccount);
        }
        else {
            playerAtlasTokenAccount = potentialAtlasTokenAccount;
        }
        // Get user's ship token account
        let shipTokenAccount;
        const shipResponse = yield (0, util_1.getTokenAccount)(connection, playerPublicKey, shipMint);
        const potentialShipTokenAccount = shipResponse.tokenAccount;
        if ('createInstruction' in shipResponse) {
            ixSet.instructions.push(shipResponse.createInstruction);
        }
        if (potentialShipTokenAccount instanceof anchor_1.web3.Keypair) {
            shipTokenAccount = potentialShipTokenAccount.publicKey;
            ixSet.signers.push(potentialShipTokenAccount);
        }
        else {
            shipTokenAccount = potentialShipTokenAccount;
        }
        // Get user's toolkit token account
        let toolkitTokenAccount;
        const response = yield (0, util_1.getTokenAccount)(connection, playerPublicKey, toolkitMint);
        const potentialToolkitTokenAccount = response.tokenAccount;
        if ('createInstruction' in response) {
            ixSet.instructions.push(response.createInstruction);
        }
        if (potentialToolkitTokenAccount instanceof anchor_1.web3.Keypair) {
            toolkitTokenAccount = potentialToolkitTokenAccount.publicKey;
            ixSet.signers.push(potentialToolkitTokenAccount);
        }
        else {
            toolkitTokenAccount = potentialToolkitTokenAccount;
        }
        const ix = yield program.instruction.processWithdrawShips(stakingBump, scoreVarsBump, scoreVarsShipBump, escrowAuthBump, escrowBump, treasuryAuthBump, treasuryBump, {
            accounts: {
                playerAccount: playerPublicKey,
                shipStakingAccount: shipStakingAccount,
                scoreVarsAccount: scoreVarsAccount,
                scoreVarsShipAccount: scoreVarsShipAccount,
                playerAtlasTokenAccount: playerAtlasTokenAccount,
                shipTokenAccountEscrow: shipEscrow,
                shipTokenAccountReturn: shipTokenAccount,
                toolkitTokenAccountSource: toolkitTokenAccount,
                treasuryTokenAccount: treasuryTokenAccount,
                treasuryAuthorityAccount: treasuryAuthorityAccount,
                escrowAuthority: escrowAuthority,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                systemProgram: anchor_1.web3.SystemProgram.programId,
                clock: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
                shipMint: shipMint,
                toolkitMint: toolkitMint,
            },
        });
        ixSet.instructions.push(ix);
        return ixSet;
    });
}
exports.createWithdrawShipsInstruction = createWithdrawShipsInstruction;
/**
 * Close all escrow accounts and ship staking accounts
 *
 * @param connection - web3.Connection object
 * @param playerPublicKey - Player's public key
 * @param shipMint - Ship mint address
 * @param fuelMint - Fuel mint address
 * @param foodMint - Food mint address
 * @param armsMint - Arms mint address
 * @param programId - Deployed program ID for the SCORE program
 */
function closeAccountsInstruction(connection, playerPublicKey, shipMint, fuelMint, foodMint, armsMint, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const [escrowAuthority, escrowAuthBump] = yield getScoreEscrowAuthAccount(programId, shipMint, playerPublicKey);
        const [shipEscrow, shipBump] = yield getScoreEscrowAccount(programId, shipMint, null, playerPublicKey);
        const [fuelEscrow, fuelBump] = yield getScoreEscrowAccount(programId, shipMint, fuelMint, playerPublicKey);
        const [foodEscrow, foodBump] = yield getScoreEscrowAccount(programId, shipMint, foodMint, playerPublicKey);
        const [armsEscrow, armsBump] = yield getScoreEscrowAccount(programId, shipMint, armsMint, playerPublicKey);
        const [scoreVarsAccount, scoreVarsBump] = yield getScoreVarsAccount(programId);
        const [shipStakingAccount, stakingBump] = yield getShipStakingAccount(programId, shipMint, playerPublicKey);
        const idl = getScoreIDL(programId);
        const provider = new anchor_1.AnchorProvider(connection, null, null);
        const program = new anchor_1.Program(idl, programId, provider);
        const ix = yield program.instruction.processCloseAccounts(stakingBump, scoreVarsBump, shipBump, fuelBump, foodBump, armsBump, escrowAuthBump, {
            accounts: {
                playerAccount: playerPublicKey,
                shipStakingAccount: shipStakingAccount,
                scoreVarsAccount: scoreVarsAccount,
                shipTokenAccountEscrow: shipEscrow,
                fuelTokenAccountEscrow: fuelEscrow,
                foodTokenAccountEscrow: foodEscrow,
                armsTokenAccountEscrow: armsEscrow,
                escrowAuthority: escrowAuthority,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                systemProgram: anchor_1.web3.SystemProgram.programId,
                shipMint: shipMint,
                fuelMint: fuelMint,
                foodMint: foodMint,
                armsMint: armsMint,
                clock: anchor_1.web3.SYSVAR_CLOCK_PUBKEY,
            },
        });
        return ix;
    });
}
exports.closeAccountsInstruction = closeAccountsInstruction;
//# sourceMappingURL=score.js.map